module.exports = __webpack_public_path__ + "img/SC3-financial.1075b92c.png";